import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { Row, Col } from 'react-flexbox-grid'

import { Form, Text, Checkbox } from 'components/forms'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import { Modal } from 'components/Modal'
import Button from 'components/Button'
import Divider from 'components/Divider'
import localDateFormatter from 'helpers/localDateFormatter'

const DatePeriod = ({ value, onChange, showDeletedRecords }) => {
	const [showModal, setShowModal] = useState(false)
	const [period, setPeriod] = useState({
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString()
	})
	const [showDeleted, setShowDeleted] = useState(false)
	const [t, language] = useTranslation()

	const getDeleted = () => {
		return showDeletedRecords ? (
			<>
				<Row>
					<Col xs>
						<Checkbox
							field='showDeleted'
							fieldState={{ value: showDeleted }}
							onChange={(event)=>setShowDeleted(event.target.checked)}
							label={t('credit_client_section.strings.show_deleted')}
							inline/>
					</Col>
				</Row>
				<Divider height={20}/>
			</>
		) : null
	}

	const submitHandler = () => {
		onChange({
			date: period,
			showDeleted
		})
	}

	return (
		<div>
			<Form onSubmit={submitHandler}>
				<Row>
					<Col xs>
						<Text
							value={localDateFormatter({ date: period?.from, language }) || ''}
							label={t('common.fields.from_date')}
							inline
							onFocus={e => setShowModal(true)}
							noForm
							shrink
							readOnly
						/>
						<Text
							value={localDateFormatter({ date: period?.to, language }) || ''}
							label={t('common.fields.to_date')}
							inline
							onFocus={e => setShowModal(true)}
							noForm
							shrink
							readOnly
						/>
					</Col>
				</Row>
				{getDeleted()}
				<Row>
					<Col xs>
						<Button type='submit' text='anwenden' />
					</Col>
				</Row>
			</Form>

			{showModal &&
				<Modal unmount={() => setShowModal(false)} label={t('common.strings.date_period')} width={500}>
					<Form
						initialValues={{ period }}
						onSubmit={values => {
							setPeriod(values?.period)
							setShowModal(false)
						}}
					>
						<DateIntervalForm />
						<Divider />
						<Button type='submit' text='anwenden' />
					</Form>
				</Modal>
			}
		</div>
	)
}

export default DatePeriod
